export const enum STATIC_ABOUT_REPORTING_GUID {
  pageId = 'G5EC58CU5PG4N2SR',
  contentId = 'GG3CKB63UG7YHYJD-GW3V7XMX3ARRGXBW'
}

export const enum STATIC_CREATE_A_REPORT_GUID {
  pageId = 'G5EC58CU5PG4N2SR',
  contentId = 'GG3CKB63UG7YHYJD-G5PEJKG3M7J2SK4G'
}
